<template>
  <div
    v-if="tableState.showTable"
    class="positioner"
  >
    <power-table
      :row-data="tableState.dataTable"
      :header-props="headerProps()"
      :active="active"
      :is-training="isTraining"
      :is-start-list="tableState.isStartList"
      :show-discipline-icon="showDisciplineIcon"
      :show-ranking-points-ssm="showRankingPoints"
      :special-record="specialRecord"
      :javelin-type="tableState.javelinType"
      class="transform-origin-top-center"
      @mousedown="oneClick"
      @touchstart="oneClick"
    />
  </div>
</template>

<script lang="ts">
import {
  requestManager,
  modes,
  playersManager,
  PlayersSortTypes,
  corePhasesManager
} from '@powerplay/core-minigames'
import { PowerTable } from '@powerplay/core-minigames-ui-ssm'
import { pathAssetsCoreUi } from '@/globals/globalvariables'

import { defineComponent } from 'vue'
import { gameConfig } from '@/app/config'
import {
  tableState,
  type TableState
} from '@/stores'

export default defineComponent({
  name: 'DataTable',
  components: {
    PowerTable
  },
  data() {

    return {
      active: false,
      specialRecord: '',
      isPB: false,
      firstClick: false,
      tableState: tableState()
    }

  },
  computed: {
    isTraining() {

      return modes.isTrainingMode()

    },
    showDisciplineIcon() {

      return modes.isBossCompetition()

    },
    showRankingPoints() {

      return !modes.isBossCompetition() && !modes.isEventBossFight()

    }
  },
  watch: {
    tableState: {
      handler(value: TableState) {

        console.log(value)
        setTimeout(() => {

          this.active = value.activeState

        }, 10)

      },
      deep: true
    },
  },
  methods: {
    oneClick(event: Event) {

      if (tableState().activeState) event.stopPropagation()

    },
    headerProps() {

      const personalBest = playersManager.getPlayer().personalBest ?? 0
      const result = playersManager.getBestResult(PlayersSortTypes.descending, undefined, true)
      let personalBestValue = personalBest

      if (tableState().resultText !== 'startList') {

        if (personalBest < result) {

          this.specialRecord = 'PB'
          this.isPB = true

        }
        if (gameConfig.worldRecord <= result) this.specialRecord = 'WR'
        personalBestValue = personalBest < result ? result : personalBest

      }
      let headerTableText = {}
      if (tableState().resultText !== 'startList') {

        headerTableText = {
          col1: '1',
          col2: '2',
          col3: '3',
          col4: '4',
          col5: '5',
          col6: '6',
          col7: this.$t('Result')
        }

        if (modes.isTournament() && corePhasesManager.disciplineActualAttempt <= 1) {

          headerTableText = {
            col1: '',
            col2: '',
            col3: '',
            col4: '',
            col5: '',
            col6: '',
            col7: this.$t('Result')
          }

        }

      }

      const pbObject = {
        showNew: this.isPB,
        value: personalBestValue === 0 ? '-' : personalBestValue.toFixed(2)
      }
      console.log(pbObject)

      if (modes.isTournament()) {

        this.specialRecord = ''
        pbObject.showNew = false
        pbObject.value = ''

      }
      
      return {
        discipline: {
          name: this.$t(`disciplineName${requestManager.disciplineID}`),
          image: `${pathAssetsCoreUi}/table/attribute-icon/disc-ico-light-05.svg`
        },
        competitonType: this.$t(tableState().competitionText),
        resultType: this.$t(tableState().resultText),
        wind: {
          show: false,
          value: ''
        },
        headerTableText,
        personalBest: pbObject,
      }

    }
  }

})

</script>

<style scoped lang="less">
.positioner {
  position: absolute;
  top: 13%;
  left: 50%;
  transform: translateX(-50%);

  .transform-origin-top-center {
      transform-origin: top center;
  }
}
</style>
